import React from 'react';
import ReactDOM from 'react-dom/client';
import DiplomaticTransitPortal from './DiplomaticTransitPortal';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <DiplomaticTransitPortal />
  </React.StrictMode>
);
